export const allAttemptsUsedVariants = {
    RETURN_TO_DESKTOP: 'All attempts used. Please return to your desktop to complete the process.',
    CONTACT_ADMIN: `You've used all available verification attempts. Please contact your administrator to continue.`,
    ALTERNATE_VERIFICATION: 'All attempts used. Please use alternate method for verification.',
    PASSED_SO_RETURN_TO_DESKTOP: 'Please return to your desktop to complete the process.',
};
